import ExplorationArticle from '../components/article';
import { MDSText } from '@midwest/web/base';
import { MDSAnchorButton } from '@midwest/web/button';
import { Link } from '@midwest/web/link';
import { Content as uiTabsContent } from '@midwest/web/tabs';
import { desktop, tablet } from '@thrivent/midwest-shared';
import nextImage from 'next/image';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const TabsContent = styled(uiTabsContent)`
  padding: 1.5rem;
`;

export const ArticleTabStyles = {
  TabsContent,
  Article: styled(ExplorationArticle)``,
};

const AdvisorButton = styled(MDSAnchorButton)`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  text-decoration: none;
  background-color: ${(p) => p.theme.midwestColors.identityBrandPrimaryMedium};

  ${tablet} {
    display: inline-flex;
  }
`;

export const FindARepTabStyles = {
  TabsContent,
  TitleText: styled(MDSText.BodyHeavyDefault)`
    margin: 1rem 0 0 0;

    &:first-of-type {
      margin-top: 0;
    }
  `,
  ContentText: styled(MDSText.BodyRegSm)`
    margin: 0.4rem 0 0 0;
  `,
  HoursText: styled(MDSText.BodyMediumXs)`
    margin: 0.2rem 0 0 0;
    color: ${(p) => p.theme.midwestColors.neutralDarkWeak};
  `,
  AdvisorButton,
  VirtualAdvisorButton: styled(AdvisorButton)`
    background-color: ${(p) => p.theme.midwestColors.white};
    color: ${(p) => p.theme.midwestColors.textLink};
    border: 2px solid ${(p) => p.theme.midwestColors.textLink};
    outline: none;
  `,
  PhoneLink: styled(Link)`
    font-weight: bold;
    text-decoration: none;
    font-size: inherit;
    color: ${(p) => p.theme.midwestColors.neutralDarkHeavy};
    display: inline-block;
  `,
};

export const QuizTabStyles = {
  TabsContent,
  QuizContainer: styled.div`
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: auto auto;

    /* made specific grid for tablet size to avoid weird spacing between text and button */
    ${tablet} {
      grid-template-columns: 1fr 3fr;
      grid-template-rows: 1fr 5fr;
    }
    ${desktop} {
      grid-template-columns: 1fr 2fr;
      grid-template-rows: auto auto;
    }
  `,
  ImageContainer: styled.div`
    ${tablet} {
      grid-column: 1;
      grid-row: 1 / 3;
    }
  `,
  ImageWrapper: styled.div`
    border: 1px solid ${(p) => p.theme.midwestColors.neutralLightStrong};
    padding: 5%;
  `,
  Image: styled(nextImage)`
    max-width: 100%;
    height: auto;
  `,
  ContentContainer: styled.div``,
  ContentText: styled(MDSText.BodyRegSm)`
    margin-block: 0;
    grid-column: 2;
    grid-row: 1;
  `,
  ContentLink: styled(MDSAnchorButton)`
    background-color: ${(p) =>
      p.theme.midwestColors.identityBrandPrimaryMedium};
    width: 100%;
    grid-column: 1 / 3;
    grid-row: 2;

    ${tablet} {
      grid-column: 2;
      grid-row: 2;
      width: fit-content;
      height: fit-content;
    }

    ${desktop} {
      grid-column: 2;
      grid-row: 2;
    }
  `,
};
